var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-loading',{attrs:{"is-full-page":"","active":"","type":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }